{
	"optionsOrders": {
		"activeOrders": {
			"filled": "Executed",
			"open": "Open",
			"canceled": "Canceled"
		},
		"ticker": "Ticker",
		"option": "Option",
		"tickerCompany": "Ticker/Company",
		"operation": "Operation",
		"quantity": "Quantity",
		"sum": "Sum",
		"profitability": "Profit",
		"dateTime": "Date/Time",
		"actions": "Actions",
		"price": "Price",
		"openedOrders": "Opened Orders",
		"statusTitle": "Status",
		"term": "Term",
		"orderStatus": "Order Status",
		"orderType": "Order Type",
		"executed": "Executed"
	}
}
